import { Disclaimer } from '@/_pages/interwill/instructions/components/Disclaimer';
import { SectionContent } from '@/_pages/interwill/instructions/components/SectionContent';
import { StyledCollapse } from '@/_pages/interwill/instructions/components/styled';
import { useContent } from '@/_pages/interwill/instructions/hooks/useContent';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { Container, Content, StyledLink, Title, TopSection } from './styled';

export const InstructionsTab = () => {
  const { t } = useTranslation('pages/pageInterwill', { keyPrefix: 'instructions' });
  const sections = useContent();

  return (
    <Container>
      <TopSection>
        <Title>{t('title')}</Title>
        <StyledLink type="link" href="/interwill/instructions">
          {t('seeInNewTab')}
        </StyledLink>
      </TopSection>
      <Disclaimer />

      <Content>
        <StyledCollapse
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <Icon name={isActive ? 'minus' : 'plus'} size="s20" color={COLORS.systemSky200} />
          )}
          defaultActiveKey={[sections[0].key]}
        >
          {sections.map((section) => (
            <StyledCollapse.Panel key={section.key} header={t(`${section.key}.title`)}>
              <SectionContent section={section} />
            </StyledCollapse.Panel>
          ))}
        </StyledCollapse>
      </Content>
    </Container>
  );
};
